const postRoles = {
  toastr: 'Added function',
  toastr: ' has been successfully added',
  toastrError: 'Function already registered',
  toastrError: 'Enter another name'
};

export default postRoles;
